import React from "react"

import * as courseSummary from "../styles/CourseSummary.module.css"

import { ChildSelector } from "../helpers/ChildSelector"

import WPImage, { DISPLAY_MODE } from "./_base/WPImage"

export default function CourseSummary(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `summary-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const subTitle = ChildSelector.select(
    content,
    `course-information-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const textStack = content.childNodes
    .filter(node =>
      node.classNames.trim().split(/\s+/).includes("course-information"),
    )
    .map(t => t.text)

  const tableContents = content.childNodes
    .filter(node => node.classNames === "course-table-contents")[0]
    .childNodes.map(t => t.text)
  return (
    <>
      {/* <div className={`row ${courseSummary.wrapper}`}>
        <div className={`col-12 ${courseSummary.holder}`}>
          <h2 className={`${courseSummary.title}`}>{title}</h2>
          <hr className={`${courseSummary.divider}`} />
        </div>
      </div> */}
      <div className={`row ${courseSummary.wrapper}`}>
        <div className={`col-xs-12 col-sm-12 col-md-6 col-lg-6 ${courseSummary.holder}`}>
          {/* <h6 className={`${courseSummary.subTitle}`}>{subTitle}</h6> */}
          {textStack.map((text, idx) => (
            <span key={idx}>
              <p className={`${courseSummary.text}`}>{text}</p>
              <hr className={`${courseSummary.linebreak}`} />
            </span>
          ))}
          <ul className={`${courseSummary.listing}`}>
            {tableContents.map((text, idx) => (
              <li key={idx} className={`${courseSummary.item}`}>
                {text}
              </li>
            ))}
          </ul>
        </div>
        <div className={`d-none d-lg-flex col-4 ${courseSummary.mediaHolder}`}>
          <WPImage
            holder={content}
            selector={`media-asset`}
            mode={DISPLAY_MODE.normal}
          />
        </div>
      </div>
    </>
  )
}
